module.exports = __webpack_public_path__ + "img/57.689c208e.png";